import {MessageLogger} from "../MessageLogger";
import {FileEntity} from "../../store/entity/FileEntity";
import app from "@/main";
import {Mixins} from "../Mixins";

interface TakipEvrak {
    name: string,
    mimeType: string,
    //base64 string
    data: string
}

export default class TakipInjectable extends MessageLogger {
    dayanaklar: TakipEvrak[] = [];
    vekalet: TakipEvrak | null = null;
    vekaletObject: FileEntity | null = null;
    dayanaklarObject: Array<FileEntity> = [];

    async setEvraklar(dosyaNode: Element): Promise<void> {
        if (dosyaNode) {
            let evraklarNodeList = dosyaNode.querySelectorAll("evraklar evrak");
            if (evraklarNodeList) {
                for (const evrakNode of Array.from(evraklarNodeList)) {
                    let evrakTuru = evrakNode.getAttribute("evrakturu");

                    // Önce detay path kontrolü yap (yeni node varsa)
                    let detayPath = Mixins.nullUndefCleaner(evrakNode.getAttribute("detaypath") || evrakNode.getAttribute("path"));

                    let evrak: TakipEvrak | null = null;

                    if (detayPath && detayPath !== "") {
                        // Detay path'i varsa dosyayı local path'den çek (MTS benzeri)
                        try {
                            let belge = await app.$imza.getFileFromLocalPath(detayPath);
                            let splited = detayPath.replace(/\\/g, "/").split("/");
                            let fileName = splited[splited.length - 1];
                            evrak = {
                                data: belge.file,
                                mimeType: Mixins.findFileMimeType(fileName),
                                name: fileName
                            };
                            console.log("Evrak detay path'den yüklendi:", fileName);
                        } catch (e) {
                            console.log("Detay path'den evrak yüklenemedi, XML içeriğine fallback:", e);
                            // Hata durumunda XML içeriğinden almayı dene
                            evrak = this.extractEvrakFromXml(evrakNode);
                        }
                    } else {
                        // Detay path yoksa eski yöntemle XML içinden al
                        evrak = this.extractEvrakFromXml(evrakNode);
                    }

                    if (evrak) {
                        if (evrakTuru == "1") // Vekalet
                            this.vekalet = evrak;
                        if (evrakTuru == "2") // Dayanak belge
                            this.dayanaklar.push(evrak);
                    }
                }
            }
        }
    }

    private extractEvrakFromXml(evrakNode: Element): TakipEvrak | null {
        try {
            return {
                name: evrakNode.getAttribute("filename") || "",
                mimeType: evrakNode.getAttribute("mimetype") || "",
                data: this.getBase64(evrakNode.innerHTML)
            };
        } catch (e) {
            console.error("XML'den evrak extract edilemedi:", e);
            return null;
        }
    }

    getBase64(str: string){
        const regex = /<!--\[CDATA\[(.*?)\]\]-->/;
        const match = str.match(regex);
        // @ts-ignore
        return match[1];
    }
}

